import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

export default class DataObject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataObject: this.props.dataObject,
      userId: this.props.userId,
      isGrantingPermission: this.props.isGrantingPermission || false,
    };
  }
  _buildLink() {
    const { dataObject, userId, isGrantingPermission } = this.state;
    let baseLink = '';

    if (dataObject.object_type === 'field') {
      baseLink = `/table/${dataObject.table_id}/field/${dataObject.id}`;
    } else {
      baseLink = `/${dataObject.object_type}/${dataObject.id}`;
    }

    if (userId && isGrantingPermission) {
      baseLink = `${baseLink}?is_granting_permission=1&user_id=${userId}`
    }
    
    return baseLink;
  }
  render() {
    const { dataObject } = this.state;
    const link = this._buildLink();
    return (
      <div className="data-object-main">
        <div className="data-object-top-info">
          <Link to={link}>
            <span className="data-object-code_name">{dataObject.code_name || dataObject.name}</span>
          </Link>
          {dataObject.object_type &&
            <span className={`data-object-type-badge ${dataObject.object_type}-badge`}>{dataObject.object_type}</span>
          }
        </div>
        {dataObject.object_type === 'datasource' &&
          <div className="">
            <p className="data-object-datasource-type">{dataObject.datasource_type}</p>
          </div>
        }
        <div className="data-object-extra-info">
          <p style={{ whiteSpace: 'pre-wrap'}}>{dataObject.description}</p>
          {dataObject.parent &&
            <p className="data-object-parent-info">Belongs to {dataObject.parent.object_type || ''}: {dataObject.parent.code_name}</p>
          }
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/DataObject/index.js